import * as React from 'react';

export default () => <div className="mb-15">
  Are you sure you want to delete this?
</div>;
